var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "box"
    },
    [
      _c(
        "div",
        { staticClass: "login_title" },
        [
          _vm.activeName !== "forget"
            ? _c(
                "el-button",
                {
                  class: ["tab-btn", "tab", _vm.loginClass],
                  staticStyle: { "margin-right": "0.38rem" },
                  attrs: { type: "text", size: "medium" },
                  on: {
                    click: function($event) {
                      return _vm.handleClick("login")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("m.login")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeName !== "forget"
            ? _c(
                "el-button",
                {
                  class: ["tab-btn", "tab", _vm.regClass],
                  attrs: { type: "text", size: "medium" },
                  on: {
                    click: function($event) {
                      return _vm.handleClick("reg")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("m.reg")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeName === "forget"
            ? _c(
                "el-button",
                {
                  class: ["tab-btn", "tab", _vm.forgetClass],
                  attrs: { type: "text", size: "medium" },
                  on: {
                    click: function($event) {
                      return _vm.handleClick("forget")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("m.forget_pwd")))]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.activeName === "login"
        ? _c("login-tab", {
            ref: "login",
            attrs: { agreeXieyi: _vm.agreeXieyi },
            on: { showForget: _vm.showForget }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeName === "reg"
        ? _c("reg-tab", { ref: "reg", attrs: { agreeXieyi: _vm.agreeXieyi } })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeName === "forget"
        ? _c("forget-pwd", { ref: "forget", on: { cancelPwd: _vm.cancelPwd } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b4c0982", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b4c0982","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/loginRegisterTab.vue
// module id = null
// module chunks = 